import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=c025d358&scoped=true"
import script from "./TopicDetail.vue?vue&type=script&lang=js"
export * from "./TopicDetail.vue?vue&type=script&lang=js"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=c025d358&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c025d358",
  null
  
)

export default component.exports